import { render, staticRenderFns } from "./RemindForAddingTeamsDialog.vue?vue&type=template&id=2603ca58&scoped=true&"
import script from "./RemindForAddingTeamsDialog.vue?vue&type=script&lang=js&"
export * from "./RemindForAddingTeamsDialog.vue?vue&type=script&lang=js&"
import style0 from "./RemindForAddingTeamsDialog.vue?vue&type=style&index=0&id=2603ca58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2603ca58",
  null
  
)

export default component.exports